import { getMoonPosition, getMoonIllumination } from 'suncalc';
import { solarPosition } from './solar.js';

const R = Math.PI / 180;
const phases = ['New Moon', 'Waxing crescent', 'First quarter', 'Waxing gibbous', 'Full Moon', 'Waning gibbous', 'Last quarter', 'Waning crescent'];

/** Sky references only; moonlight is not an input to the lighting solver.
 * SunCalc 2 uses degrees and azimuth clockwise from north. Keep the existing
 * solar model for the Sun so its disc remains aligned with direct shadows. */
export function celestialPositions(environment = {}, timestamp) {
  const { latitude, longitude } = environment;
  if (!timestamp || !Number.isFinite(Date.parse(timestamp)) || !Number.isFinite(latitude) || Math.abs(latitude) > 90 || !Number.isFinite(longitude) || Math.abs(longitude) > 180) return null;
  const north = Number.isFinite(environment.north) ? environment.north : 270;
  const sun = solarPosition(timestamp, latitude, longitude, north);
  const date = new Date(timestamp), position = getMoonPosition(date, latitude, longitude), illumination = getMoonIllumination(date);
  const az = (north + position.azimuth) * R, el = position.altitude * R;
  // Bright limb angle is anticlockwise from the screen's upward vertical.
  // The local sphere normal faces the observer along its positive Z axis.
  const tilt = (illumination.angle - position.parallacticAngle) * R;
  const z = 2 * illumination.fraction - 1, tangent = Math.sqrt(Math.max(0, 1 - z * z));
  return {
    sun: { ...sun, direction: [sun.direction.x, sun.direction.z, sun.direction.y] },
    moon: { azimuth: position.azimuth, elevation: position.altitude,
      direction: [Math.cos(az) * Math.cos(el), Math.sin(el), Math.sin(az) * Math.cos(el)],
      radius: Math.asin(1737.4 / position.distance), fraction: illumination.fraction,
      phase: phases[Math.round(illumination.phase * 8) % 8],
      lightDirection: [-Math.sin(tilt) * tangent, Math.cos(tilt) * tangent, z] }
  };
}

export function skyBearing(body) {
  if (!body) return '';
  const compass = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'][Math.round(body.azimuth / 45) % 8];
  return body.elevation <= 0 ? 'Below the horizon' : `${compass} · ${Math.round(body.elevation)}° above horizon`;
}
